<template>
  <div>
    
    <div id="preview">
      <img :src="results['logofile']" />
    </div>
    
    <section>

      <h2> Choose your markets and plans </h2>
    
      <hr/>

      <b-container class="bv-example-row">

        <b-row>
  
          <b-col cols="8">

            <div class="form-group mb-6" v-bind:class="{ 'has-error': $v.market.$error }">
  
              <h3>Markets</h3>
            
              <hr/>

              <div class="form-check ml-4">
                <input class="form-check-input" type="checkbox" v-model.trim="market" @input="$v.market.$touch()" v-on:click="adjustplans($event)" name="Residential" value="Residential" id="flexCheckDefault1">
                <label class="form-check-label" for="flexCheckDefault1">
                  Residential
                </label>
              </div>

              <div class="form-check ml-4">
                <input class="form-check-input" type="checkbox" v-model.trim="market" @input="$v.market.$touch()" v-on:click="adjustplans($event)" name="Commercial" value="Commercial" id="flexCheckDefault2">
                <label class="form-check-label" for="flexCheckDefault2">
                  Commercial
                </label>
              </div>

              <span class="help-block" v-if="$v.market.$error && !$v.market.required">Market should be selected.</span>
            </div>

            <div class="form-group mt-4" v-bind:class="{ 'has-error': $v.plans.$error }">

              <h3>Plans</h3>
            
              <hr/>

              <div class="form-check ml-4" v-for="item in planlist" :key="item.lable">
                <input class="form-check-input" type="checkbox" v-model.trim="plans" @input="$v.plans.$touch()" :name="item.value" :value="item.value" :id="item.value">
                <label class="form-check-label" :for="item.value">{{item.label}}</label>
              </div>

              <span class="help-block" v-if="$v.plans.$error && !$v.plans.required">Plans should be selected.</span>
          
            </div>

          </b-col>

          <b-col cols="4">
            <b-img :src="require('./assets/images/slide-02.png')" fluid alt="smartbox smartbilling"></b-img>
          </b-col>
      
        </b-row>
  
      </b-container>
  
    </section>

  </div>

</template>

<script>

const { required } = require('vuelidate/lib/validators')

export default {
  name: 'StepMarket',
  props: ['results'],  
  data() {
    return {
      market: [],
      plans: [],
      planlist: this.$Plans
    }
  },
  validations: {
    market: {
    },
    plans: {
    },
    form: ['market', 'plans']
  },
  methods: {
    validate() {
      this.$v.form.$touch();
      var isValid = !this.$v.form.$invalid
      this.$emit('on-validate', this.$data, isValid)
      return isValid  
    },
    adjustplans(e) {
      
      var pos = 0;

      if (e.target.checked) { // some options are selected 
        if (e.target.value == "Residential") {  // residential is selected
          if (this.market.indexOf("Commercial") != -1) {  // commercial is also selected
            pos = this.planlist.map(function(p) { return p.label; }).indexOf('Utilities (ex. gas, electricity)');
            if (pos == -1) {
              this.planlist.splice(3, 0, { label: "Utilities (ex. gas, electricity)", value: "Utilities (ex. gas, electricity)"});            
            }               
            pos = this.planlist.map(function(p) { return p.label; }).indexOf('IoT (Internet of Things)');
            if (pos == -1) {
              this.planlist.push({ label: "IoT (Internet of Things)", value: "IoT (Internet of Things)"});            
            }              
          } 
          else {  // commercial is not selected
            // then IOT plans should not display
            pos = this.planlist.map(function(p) { return p.label; }).indexOf('IoT (Internet of Things)');
            if (pos != -1) {
              this.planlist.splice(pos,1);            
            }
          }          
        }
        else {  // commercialplan is selected
          if (this.market.indexOf("Residential") != -1) {  // residentialplan is also selected
            pos = this.planlist.map(function(p) { return p.label; }).indexOf('Utilities (ex. gas, electricity)');
            if (pos == -1) {
              this.planlist.splice(3, 0, { label: "Utilities (ex. gas, electricity)", value: "Utilities (ex. gas, electricity)"});            
            }               
            pos = this.planlist.map(function(p) { return p.label; }).indexOf("IoT (Internet of Things)");
            if (pos == -1) {
              this.planlist.push({ label: "IoT (Internet of Things)", value: "IoT (Internet of Things)"});            
            }    
          }      
          else {  // residentialplan is not selected
            // then Utilities plans should not display
            pos = this.planlist.map(function(p) { return p.label; }).indexOf('Utilities (ex. gas, electricity)');
            if (pos != -1) {
              this.planlist.splice(pos,1);            
            }
          }
        }
      }
      else { // some options are unselected
        if (e.target.value == "Residential") {  // residential is unselected
          if (this.market.indexOf("Commercial") != -1) {  // commercial is still selected
            pos = this.planlist.map(function(p) { return p.label; }).indexOf('Utilities (ex. gas, electricity)');
            if (pos != -1) {
              this.planlist.splice(pos,1);            
            }
            pos = this.planlist.map(function(p) { return p.label; }).indexOf('IoT (Internet of Things)');
            if (pos == -1) {
              this.planlist.push({ label: "IoT (Internet of Things)", value: "IoT (Internet of Things)"});            
            }                                    
          }
          else {
            pos = this.planlist.map(function(p) { return p.label; }).indexOf('Utilities (ex. gas, electricity)');
            if (pos == -1) {
              this.planlist.splice(3, 0, { label: "Utilities (ex. gas, electricity)", value: "Utilities (ex. gas, electricity)"});            
            }
            pos = this.planlist.map(function(p) { return p.label; }).indexOf("IoT (Internet of Things)");
            if (pos == -1) {
              this.planlist.push({ label: "IoT (Internet of Things)", value: "IoT (Internet of Things)"});            
            } 
          }
        }
        else { // commercial is unselected
          if (this.market.indexOf("Residential") != -1) {  // residential is still selected
            pos = this.planlist.map(function(p) { return p.label; }).indexOf('IoT (Internet of Things)');
            if (pos != -1) {
              this.planlist.splice(pos,1);            
            }
            pos = this.planlist.map(function(p) { return p.label; }).indexOf('Utilities (ex. gas, electricity)');
            if (pos == -1) {
              this.planlist.push({ label: "Utilities (ex. gas, electricity)", value: "Utilities (ex. gas, electricity)"});            
            }                                    
          }
          else {
            pos = this.planlist.map(function(p) { return p.label; }).indexOf('Utilities (ex. gas, electricity)');
            if (pos == -1) {
              this.planlist.splice(3, 0, { label: "Utilities (ex. gas, electricity)", value: "Utilities (ex. gas, electricity)"});            
            }
            pos = this.planlist.map(function(p) { return p.label; }).indexOf("IoT (Internet of Things)");
            if (pos == -1) {
              this.planlist.push({ label: "IoT (Internet of Things)", value: "IoT (Internet of Things)"});            
            } 
          }
        }
      }
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/StepMarket.vue